var map = {
	"./404.svg": 503,
	"./bug.svg": 504,
	"./chart.svg": 505,
	"./clipboard.svg": 506,
	"./component.svg": 507,
	"./dashboard.svg": 508,
	"./documentation.svg": 509,
	"./drag.svg": 510,
	"./edit.svg": 511,
	"./email.svg": 512,
	"./example.svg": 513,
	"./excel.svg": 514,
	"./eye.svg": 515,
	"./form.svg": 516,
	"./guide 2.svg": 517,
	"./guide.svg": 518,
	"./icon.svg": 519,
	"./international.svg": 520,
	"./language.svg": 521,
	"./link.svg": 522,
	"./list.svg": 523,
	"./lock.svg": 524,
	"./message.svg": 525,
	"./money.svg": 526,
	"./nested.svg": 527,
	"./password.svg": 528,
	"./people.svg": 529,
	"./peoples.svg": 530,
	"./qq.svg": 531,
	"./shopping.svg": 532,
	"./size.svg": 533,
	"./star.svg": 534,
	"./tab.svg": 535,
	"./table.svg": 536,
	"./theme.svg": 537,
	"./tree.svg": 538,
	"./user.svg": 539,
	"./wechat.svg": 540,
	"./zip.svg": 541
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 502;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = 502
// module chunks = 75